import { useContext } from 'react';
import { MessageContext } from './MessageContext';

export * from './MessageContext';

export const useMessageContext = () => useContext(MessageContext);
